export default {
	UPGRADE_CLICK: 'upgrade_button_click',
	BUILDER_VIEW: 'builder_view',
	OPTIMIZE_BUILDER_VIEW: 'optimize_builder_view',
};
